// extracted by mini-css-extract-plugin
export var box = "_3l-0";
export var check = "_3l-1";
export var checkboxButton = "_3l-6";
export var checkboxGroup = "_3l-5";
export var disabled = "_3l-7";
export var ghost = "_3l-9";
export var input = "_3l-2";
export var label = "_3l-4";
export var normal = "_3l-8";
export var uncheck = "_3l-3";